module.exports = __webpack_public_path__ + "img/M.f8051c86.png";